import {  LogoProductModel, ProductProps } from "models/WebShop";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CartProvider, useCart } from "react-use-cart";
import ImageUploadArea from "components/ImageUploadArea";
import { addCloudinaryTransformation, fromBase64, toBase64 } from "utility/ImgUtilities";
import CloudinaryService from "services/CloudinaryService";
import { cloudinaryService } from "services/Services";
import PromoPreview from "components/PromoPreview";




const LogoProduct = ({ handleAddProduct, handleFormValidation, initialProduct }: ProductProps) => {
    const params = useParams();
    const cart = useCart();
    const [imgLoaded, setimgLoaded] = useState<boolean>(false);
    const [logoImg, setLogo] = useState<File | null>(null);
    // const [previewFile, setPreviewFile] = useState<File | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);

    const logo: LogoProductModel = {
        id: params.id ? params.product + params.id : "",
        webShopProductId: 101,
        documentId: params.id ?? "",
        path: "",
        price: 1500,
        basePrice: 1500,
        name: "Logo",
        payload: "",
        img: "",
        url: "",
        description: "",
        linkText: ""
    }

    useEffect(() => {
        async function getData() {
            if (initialProduct !== undefined && initialProduct !== null) {
                try {
                    const init = fromBase64(initialProduct.img, "initial.jpg");
                    // setPreviewFile(init);
                    setLogo(init);
                    handleAddProduct(initialProduct);
                }
                catch {
                }
            }
        }
        getData();
        setimgLoaded(true);
    }, []);

    useEffect(() => {
        if (imgLoaded){
            generateImageUrl();
        }

    },[imgLoaded, logoImg]);

    const addProduct = async (file: File | null) => {
        let lookupId = logo.webShopProductId + logo.documentId;

        if (file !== null && !cart.inCart(lookupId)) {
            // setPreviewFile(file);
            let encodedImg = await toBase64(file);
            if (typeof encodedImg === 'string') {
                logo.img = encodedImg;
                handleAddProduct(logo);
                handleFormValidation(true);
                setLogo(file);
                
            }
        }
        else {
            handleAddProduct(null);
            handleFormValidation(false);

        }
    }

     const generateImageUrl = async () => {
        if (logoImg !== null){
            let img = await toBase64(logoImg) as File
            const response = await cloudinaryService.uploadImage(img);
            if (response !== undefined && response.secure_url !== undefined){
                const url = addCloudinaryTransformation(response.secure_url,"t_www-logo_v2");
                setPreviewUrl(url);
            }
        }
    }

    return (
        <>
        <p className="text-muted mb-4">Logoen du laster opp skal være et varemerke eller grafisk symbol som representerer firmaet ditt. Den må ikke være et bilde av ansatte, personer eller fotografier, da formålet med logoen er å gi virksomheten en gjenkjennelig og profesjonell identitet.</p>
            {imgLoaded &&  <ImageUploadArea onFileChange={addProduct} initialImg={logoImg ?? null} />}
            {previewUrl && <PromoPreview id={params.id ?? ""} logo={previewUrl ?? ""}/>}
        </>
    )
}

export default LogoProduct;